import { DesignSystem } from "../design-system.js";
import { OptionGroup } from "./option-group.js";
import { styles } from "./option-group.styles.js";
import { template } from "./option-group.template.js";
/**
 * The Fabric OptionGroup Element definition.
 *
 * @public
 * @remarks
 * HTML Element: `<fabric-option-group>`
 */
export const definition = OptionGroup.compose({
    name: `${DesignSystem.prefix}-option-group`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=option-group.definition.js.map